<ng-container *ngIf="!initialDataLoading; else loadingScreen">
  <ng-container *ngIf="!migrationProcess">

    <div class="db-migrate-website">
      <form class="db-migrate-website__body" [formGroup]="migrateWebsiteForm" (ngSubmit)="submit()">
        <div>
          <p *ngIf="displayWebsiteUrl" class="website-title mb15">
            <i class="db-icon db-icon-ds-globe"></i>
            <span>{{displayWebsiteUrl}}</span>
          </p>
          <h2 class="db-migrate-website__title mb25">Migrate your website</h2>
          <div class="ds-input-wrap static mb30">
            <span class="ds-input-label">Subdomain</span>
            <div class="db-migrate-website__subdomain">
              <input type="text" class="ds-input-black" maxlength="56"
                     [class.error]="formSubmitted && migrateWebsiteForm?.get('subdomain')?.errors"
                     placeholder="*subdomain" formControlName="subdomain">
              <span>.{{configHostname}}</span>
            </div>
            <span *ngIf="formSubmitted && migrateWebsiteForm?.get('subdomain')?.errors" class="ds-input-error-msg"
                  [innerHTML]="migrateWebsiteForm?.get('subdomain')?.errors['required'] ?
                'This field is required.':
                migrateWebsiteForm?.get('subdomain')?.errors?.pattern ? ('text_fillFieldAllowedLetters' | dbText) :
                migrateWebsiteForm?.get('subdomain')?.errors?.taken ? migrateWebsiteForm?.get('subdomain')?.errors?.taken
                : ''"></span>
            <span class="ds-input-desc">{{ 'text_subDomainDescription' | dbText}}</span>

          </div>

          <div class="ds-input-wrap static mb30">
            <ds-dropdown [dsDropdownOptions]="regions" formControlName="region"
                         [dsDropdownDisabled]="userSubscription?.type === UserSubscriptionCategory.DedicatedVM"
                         [dsDropdownLabel]="('text_regionDescription' | dbText)"></ds-dropdown>
          </div>
        </div>

        <db-migrate-website-footer [showManualMigration]="showManualMigration"
                                   [loading]="loading"
                                   (manualRequested)="showManualMigrationModal()"
                                   (submitted)="submit()"></db-migrate-website-footer>
      </form>
      <div class="db-migrate-website__image-section">
        <img src="assets/images/migration/migrate_website_black_bg.png" alt=""/>
      </div>
    </div>
  </ng-container>

  <db-migration-progress
    *ngIf="migrationProcess && !initialDataLoading"
    (resized)="resizeModal(600, $event)"
    (succeed)="showMigrationSuccessModal($event, zipUploading)"
    (failed)="showManualMigrationModal(true)"></db-migration-progress>
</ng-container>



<ng-template #loadingScreen>
  <db-loading-screen [pageBlocker]="true"></db-loading-screen>
</ng-template>
